module.exports = __webpack_public_path__ + "static/media/diploma.e302df87.svg";